// extracted by mini-css-extract-plugin
export default {"container":"QuizPromotionBanner_container__sbiXC","dismissButton":"QuizPromotionBanner_dismissButton__25nek","dismissIcon":"QuizPromotionBanner_dismissIcon__W7d4O"};